import { postRequest } from "../utils/api";

export const createUserRequest = async (values) => {
  const response = await postRequest("/Account/CreateNewUser", values);

  return response;
};
